import { Type } from "class-transformer";
import { FormGroupCompanyService } from "../../services/forms/form-group-company.service";
import { BaseModel } from "../base.model";
import { FormGroupInstance } from "./form-group-instance.model";

export class FormGroupCompany extends BaseModel {
  id: number;
  externalId: string;
  name: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  postCode: string;
  country: string;
  postalAddress: string;
  postalAddressCity: string;
  postalAddressPostCode: string;
  postalAddressState: string;
  clientCategory: string;
  orgId: string;
  rurality: string;
  @Type(() => require("./form-group-instance.model").FormGroupInstance)
  formGroupInstance: FormGroupInstance;
  formGroupInstanceId: number;
  @Type(() => Boolean)
  isPrimary: boolean;
  onlineLogo: string;
  signedLogoUrl: string;

  /**
   * @description Sets the signed logo URL for the company via an API call
   * @param formGroupCompanyService
   */
  public async setSignedLogoUrl(formGroupCompanyService: FormGroupCompanyService): Promise<void> {
    if (this.onlineLogo) {
      this.signedLogoUrl = await formGroupCompanyService.getLogoSignedUrl(this.id);
    }
  }
}
